import { render, staticRenderFns } from "./MedicalFormulaUsageRecord.vue?vue&type=template&id=7769406a&scoped=true"
import script from "./MedicalFormulaUsageRecord.vue?vue&type=script&lang=js"
export * from "./MedicalFormulaUsageRecord.vue?vue&type=script&lang=js"
import style0 from "./MedicalFormulaUsageRecord.vue?vue&type=style&index=0&id=7769406a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7769406a",
  null
  
)

export default component.exports